import { ValidatorFn } from "@angular/forms";

export enum ValidatorFlags {
    none,
    required
}
export interface GCValidatorFn extends ValidatorFn {
    flags: ValidatorFlags;
}
